function showPrice(price) {
  return `¥${(price / 100).toFixed(2)}`;
}

export default showPrice;
